import { getColor } from '@klappir/ui/brand';
import styled from '@klappir/vendor/styled';

export const Code = styled.code`
  padding: 0.2em 0.4em;
  background-color: ${getColor('gray', 20)};
`;
